import { Box } from "@/storybook-components";
import { BazaarComponent } from "./index";

/**
 * Base bazaar item component
 * used to define neccessary spacing around the element
 */
const BazaarItem = ({ children, ...rest }: BazaarComponent): JSX.Element => {
  return (
    <Box mx={5} my={4} className="ehq-item" {...rest}>
      {children}
    </Box>
  );
};

export default BazaarItem;
